import axios from "axios";

import Config from "../../../config";

// Remove o webhook no Telegram e limpa as credenciais do canal.
const v1_actionTelegramDesconectar = (data) => {
    let url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/canais/telegram/disconnect`;
    return axios({
        method: "post",
        url: url,
        data: data
    });
};

export default v1_actionTelegramDesconectar;
